<template>
	<div class="info-dialog">
		<AppDialog :dialogName="dialogName" width="640">
			<div class="info-dialog-content">
				<div class="dialog-body">
					<p v-html="htmlContent" />
				</div>
				<div class="dialog-bottom text-align-center">
					<PrimaryButton class="btn-confirm" @click="close()"> Close </PrimaryButton>
				</div>
			</div>
		</AppDialog>
	</div>
</template>

<script>
import { sanitizeHtml } from '@/utils/helpers';

import AppDialog from '../AppDialog/AppDialog';

import AppDialogManagerService from '../AppDialogManager/app-dialog-manager-service';

export default {
	name: 'InfoDialog',
	components: {
		AppDialog,
	},
	props: {
		dialogName: { type: String }, //Todo: extract into a DialogMixin
		htmlContent: { type: String },
	},
	methods: {
		close() {
			AppDialogManagerService.closeCurrentDialog();
		},
	},
	computed: {
		cleanHtml() {
			return sanitizeHtml(this.htmlContent);
		},
	},
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
.info-dialog-content {
	.dialog-body {
		max-height: 70vh;
		overflow-y: auto;
	}
}
</style>
